import { render, staticRenderFns } from "./sendVerifyToken.vue?vue&type=template&id=5538480e"
import script from "./sendVerifyToken.vue?vue&type=script&lang=js"
export * from "./sendVerifyToken.vue?vue&type=script&lang=js"
import style0 from "./sendVerifyToken.vue?vue&type=style&index=0&id=5538480e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports